import { organisationConstants } from '../../../_constants';

const initialState = {
    organisation_fitments_loading: true,
    organisation_fitments: [],
    organisation_fitments_error: false, 
    organisation_fitments_error_data: {}
};

export function getAllottedOrganistionFitments(state = initialState, action) {
    switch (action.type) {
        case organisationConstants.REQUEST_GET_ALLOTED_ORGANISATION_FITMENTS:
            return {
                organisation_fitments_loading: true,
                organisation_fitments: [],
                organisation_fitments_error: false, 
                organisation_fitments_error_data: {}
            };
        case organisationConstants.RECEIVE_GET_ALLOTED_ORGANISATION_FITMENTS:
            return {
                organisation_fitments_loading: false,
                organisation_fitments: action.allotted_organisation_fitments,
                organisation_fitments_error: false,
                organisation_fitments_error_data: {}
            };
        case organisationConstants.GET_ALLOTED_ORGANISATION_FITMENTS_ERROR:
            return {
                organisation_fitments_loading: false,
                organisation_fitments: [],
                organisation_fitments_error: true,
                organisation_fitments_error_data: action.error
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/roleFitmentReport/getAllottedOrganistionFitments.reducer.js